export enum PROVIDERS_TABS {
  PROCESSING = 'processing',
  QUARANTINED = 'quarantined',
}

export interface INavigationTabs {
  value: string;
  label: string;
  enableBadge?: boolean;
  badgeCount?: number;
}

export const getProvidersTabs = (quarantinedProvidersCount: number): INavigationTabs[] => [
  {
    label: 'Processing',
    value: PROVIDERS_TABS.PROCESSING,
  },
  {
    label: 'Quarantined',
    value: PROVIDERS_TABS.QUARANTINED,
    enableBadge: !!quarantinedProvidersCount,
    badgeCount: quarantinedProvidersCount,
  }
];

export interface IReleaseState {
  isOpen: boolean;
  providerId: string;
}
